// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"38ff3c8b57378ac3b8b6","303":"5dfdcb6df07844c26f97","495":"d164a81484b4fc05309d"}[chunkId] + ".js";
};